import type { AiTable as AiTableData } from '@apis/aiAgent';

/**
 * Reading a forecast back out of the table the weather section carries. Pure,
 * so the cards that draw it stay a component file.
 */
export interface ForecastDay {
  date: string;
  condition: string;
  low: number;
  high: number;
  risk: 'low' | 'medium' | 'high';
}

const RISK_LEVELS: readonly ForecastDay['risk'][] = ['low', 'medium', 'high'];

const isRisk = (value: unknown): value is ForecastDay['risk'] =>
  typeof value === 'string' && (RISK_LEVELS as readonly string[]).includes(value);

function asDay(row: Record<string, unknown>): ForecastDay | null {
  const { date, condition, low, high, risk } = row;
  if (typeof date !== 'string' || typeof condition !== 'string') return null;
  if (typeof low !== 'number' || typeof high !== 'number' || !isRisk(risk)) return null;
  return { date, condition, low, high, risk };
}

/** The forecast days a table holds, or null when any row is not one. */
export function forecastDaysOf(table: AiTableData): ForecastDay[] | null {
  const days = table.rows.map(asDay);
  return days.every((day): day is ForecastDay => day !== null) ? days : null;
}
